import { render, staticRenderFns } from "./PerDayVoyageReport.vue?vue&type=template&id=1ad066f8&"
import script from "./PerDayVoyageReport.vue?vue&type=script&lang=js&"
export * from "./PerDayVoyageReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports